import React, { Component } from 'react';
import { getModuleList } from './GetListRequests';
import ReactLoading from 'react-loading';

import './ModuleList.css';

import Module from './Module';

class ModuleList extends Component {
  state = { 
    moduleList : null,
  }


  componentDidMount() {
    const { callBackGetModuleList } = this;
    getModuleList(callBackGetModuleList);
  }
  callBackGetModuleList = (response) => {
    
    const { data } = response;
    const { statusCode } = data;
    
    switch(statusCode) {
      case 200:
      const { property } = data;
      const { moduleList } = property;
      this.setState({
        moduleList : moduleList.map( _module => ({
          ..._module,
          expand : false,
        })),
      })
      break;

      case 403:
      alert("서버에서 거부하였습니다.");
      break;

      case 500:
      alert("서버에서 에러가 발생하였습니다. 잠시 후 다시 시도해주세요");
      break;

      default:
      alert("에러가 발생하였습니다.");
    }
  }

  renderModuleList = (moduleList) => {
    // Loading..
    if (!moduleList) {
      return (
        <div className="loading-icon-wrapper">
          <ReactLoading type={"spinningBubbles"} color="gray" />
        </div>
      );
    }
    
    const renderedModules = moduleList.map( (module, i) => {
      const { id } = module; // updateID
      const { js_name } = module;
      const { js_script } = module;
      const { state } = module;
      const { manager_id } = module;
      const { description } = module;
      const { expand } = module;
      const { created_time } = module;
      const { last_modified_time } = module;
      return (
        <Module
          key={i}
          id={id}
          moduleName={js_name}
          moduleScript={js_script}
          description={description}
          owner={manager_id}
          state={state}
          expand={expand}
          createdTime={created_time}
          lastUpdatedTime={last_modified_time}
          toggleExpand={this.toggleModuleExpand}
        />
      );
    });
    
    return (
      <ModuleStack moduleList={renderedModules} />
    );
  }

  toggleModuleExpand = (id) => {
    this.setState({
      moduleList : this.state.moduleList.map( _module => {
        if (_module.id === id) {
          return {
            ..._module,
            expand : !_module.expand,
          }
        }
        return {
          ..._module,
          expand : false,
        };
      })
    })
  }

  render() {
    const { moduleList } = this.state;
    const { renderModuleList } = this;
    const renderedModuleList = renderModuleList(moduleList);

    

    return (
      <div className="module-list">
        {renderedModuleList}
      </div>
    );
  }
}

const ModuleStack = (props) => {
  const { moduleList } = props;
  return (
    <div className="module-stack">
      {moduleList}
    </div>
  );
}

export default ModuleList;